module.exports = __webpack_public_path__ + "img/202308030937092777h6.39e02770.jpg";